import { primary, secondary } from 'rp-navigation';

/**
 * @name results.controller:directiveRaceCourse
 * @description
 * # directiveRaceCourse controller
 * Controller for raceCourse directive
 */
export default function ($scope, CommonFunctions, userPreference) {
    'ngInject';

    /**
     * Initial state of variables for RaceCourse directive
     * @type {object/null} isErrorMessageShown Flag for error message
     */
    let isErrorMessageShown = true;
    /**
     * Gets pedigree user preference
     */
    $scope.getIsPedigreeSelected = () => userPreference.get(userPreference.TYPE_PEDIGREE);

    /**
     * Toggles pedigree state
     */
    $scope.togglePedigree = () => {
        userPreference.toggle(userPreference.TYPE_PEDIGREE);
        userPreference.initHideTodaysOffersPanel();
    };

    /**
     * Primary menu results item getter
     * @returns {object} Results item from primary navigation
     */
    $scope.getPrimaryNavigationItemResults = () => primary.getItemByTitle('Results');
    /**
     * Navigation items getter
     * @returns {Array} Array of secondary navigation items
     */
    $scope.getSecondaryNavigationItems = () =>
        secondary.getItemsBySelector('.rn-secondaryNav__list__link').slice(0, -2);
    /**
     * Click handler for ListSortCourse button
     */
    $scope.onClickListSortCourse = () => {
        $scope.getPrimaryNavigationItemResults().clearItemState();
        $scope.getSecondaryNavigationItems().forEach((element) => {
            element.clearItemState();
        });
    };

    /**
     * Click handler for ListSortItem button
     */
    $scope.onClickListSortTime = () => {
        $scope.getPrimaryNavigationItemResults().setItemState({
            path: 'time-order'
        });
    };

    $scope.getIsErrorMessageShown = () => isErrorMessageShown;

    /*
     * Set isErrorMessageShown to false
     */
    $scope.hideErrorMessage = () => {
        isErrorMessageShown = false;
    };


    $scope.$on('hideErrorMessage', () => {
        $scope.hideErrorMessage();
    });
}



// WEBPACK FOOTER //
// ./src/js/controllers/directiveRaceCourse.js